import { Injectable } from '@angular/core';
import { HttpService } from '../../service/http.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RecalculateMemberPointService {
 constructor(private httpService: HttpService) { }

  getActiveMemberList(params: any): Observable<any> {
    return this.httpService.post('active-member-list', params);
  }
  recalculateMemberPoint(params: any): Observable<any> {
    return this.httpService.post('recalculate-member-point', params);
  }
  searchMember(params: any): Observable<any> {
    return this.httpService.post('sales-transaction/get-member-by-phone', params);
  }
}
